import { MeasureCatalog } from '../../models/MeasureCatalog';
import { Cr13HazardTableEntry } from '../cr13-hazard-table/models/Cr13HazardTableEntry';
import { ChoiceDTO } from '../models/ChoiceDTO';
import { SelectedTreeNode } from '../models/TreeMenu';

export interface Cr13State {
    selectedTreeNode: SelectedTreeNode | null;
    hazardToShowOnTable: Cr13HazardTableEntry[];
    measureCatalog: MeasureCatalog[];
    loadingMeasureCatalog: boolean;
    isNewHazardCreation: boolean;
    isNewMeasureCreation: boolean;
    showCountermeasureFormPopup: boolean;
    validatingMeasure: boolean;
    gettingUser: boolean;
    choiceData: ChoiceDTO[];
    searchingChoiceData: boolean;
    loadingActionOnTable: boolean;
    isTreeExpanded: boolean;
    showCountermeasuresResponsiblePopup: boolean;
}

export const initialState: Cr13State = {
    selectedTreeNode: {
        nodeData: [],
        nodeTitle: 'PAGE.MM_13.ALL_HAZARDS.LBL',
        isLastChild: false
    },
    hazardToShowOnTable: [],
    measureCatalog: [],
    loadingMeasureCatalog: false,
    isNewHazardCreation: false,
    isNewMeasureCreation: false,
    showCountermeasureFormPopup: false,
    validatingMeasure: false,
    gettingUser: false,
    choiceData: [],
    searchingChoiceData: false,
    loadingActionOnTable: false,
    isTreeExpanded: true,
    showCountermeasuresResponsiblePopup: false
};

export const featureKey = 'cr13Module';
